module.exports = __webpack_public_path__ + "img/logo.f33d8cf8.svg";